import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Image Config"})
export default class ImageViewConfig {

	@Input({
		type: InputType.CHECKBOX,
		title: "Use Image Inherent Size"
	})
	public useInherentImageSize?: boolean;

	@Input({type: InputType.COLOR, title: "Background Color"})
	public backgroundColor?: string;

	@Input({type: InputType.TEXT, title: "Default Image"})
	public defaultSrc?: string;

	@Input({type: InputType.OBJECT_FIT, title: "Image Fit"})
	public objectFit?: string;

	@Input({type: InputType.OBJECT_POSITION, title: "Image Position"})
	public objectPosition?: string;

	@Input({type: InputType.CHECKBOX, title: "Repeating Background"})
	public backgroundRepeat?: boolean;

	@Input({type: InputType.UNIT, title: "Height"})
	public height: string;

	@Input({type: InputType.UNIT, title: "Width"})
	public width: string;

	@Input({type: InputType.UNIT, title: "Border Radius"})
	public borderRadius: string;

	@Input({type: InputType.UNIT, title: "Max Height"})
	public maxHeight: string;

	@Input({type: InputType.UNIT, title: "Min Height"})
	public minHeight: string;

	@Input({type: InputType.UNIT, title: "Max Width"})
	public maxWidth: string;

	@Input({type: InputType.UNIT, title: "Min Width"})
	public minWidth: string;

	@Input({type: InputType.PADDING, title: "Padding"})
	public padding?: string;

	@Input({type: InputType.CHECKBOX, title: "Auto-equalize height"})
	public autoEqualize: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show New Banner"})
	public showNew: boolean;

}



// WEBPACK FOOTER //
// ./src/common/views/image/ImageViewConfig.ts